import { defineStore } from 'pinia'

export const useScannedQrStore = defineStore('scannedQr', {
  state: () => ({
    qrCode: null,
  }),
  actions: {
    setQrCode(code) {
      this.qrCode = code
    },
    clearQrCode() {
      this.qrCode = null
    }
  }
})